import type { FC } from 'react';
import { useMemo } from 'react';
import { Flex } from '@chakra-ui/react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import { useFooterExtraImagesQuery } from 'hooks';


const FooterExtra: FC = () => {
  const footerExtraImageData = useFooterExtraImagesQuery();

  const footerExtraImages = useMemo(() => {
    return footerExtraImageData
      ? footerExtraImageData.map((image) => ({ image: getImage(image.data), alt: image.name }))
      : [];
  }, []);

  if (!footerExtraImages.length) {
    return null;
  }

  return (
    <Flex as='ul' p={0} gap={4} flexWrap='wrap' direction='row-reverse' justifyContent='center'>
      {footerExtraImages.map(({ image, alt }, index) => (
        <Flex key={index} as='li' listStyleType='none'>
          <GatsbyImage image={image!} alt={alt} />
        </Flex>
      ))}
    </Flex>
  );
};

export default FooterExtra;
